/// <amd-module name="Wit/BacklogsHub/BacklogSettings/Utils/SaveSettingsUtil" />
import { TeamContext } from "Tfs/Platform/Contracts/Core";
import { IVssPageContext } from "VSS/Platform/Context";
import {
    IAutomationRulesRequestModel,
    IObservableAutomationRulesStatesViewData
} from "Wit/BacklogsHub/BacklogSettings/Components/AutomationSettingsView/AutomationSettingsInterfaces";
import { getAutomationRulesStateData } from "Wit/BacklogsHub/BacklogSettings/Components/AutomationSettingsView/AutomationTab";
import { IWorkRestClient } from "Wit/Clients/Work/RestClient/Work";

export async function saveWorkItemAutomationRules(
    pageContext: IVssPageContext,
    teamContext: TeamContext,
    rulesData: IObservableAutomationRulesStatesViewData,
    backlogLevelName: string
): Promise<void> {
    const workClient = pageContext.getRestClient<IWorkRestClient>("IWorkRestClient");
    const automationRulesStateData = getAutomationRulesStateData(rulesData);
    const requestModel: IAutomationRulesRequestModel = {
        backlogLevelName: backlogLevelName,
        rulesStates: automationRulesStateData
    };
    await workClient.updateAutomationRule(requestModel, teamContext);
}
